import React from 'react';
import { Text } from '@croquiscom-pvt/zds';

import { MessageSection } from '../../types';

interface Props {
  item: MessageSection;
  variant?: 'Body_14_Regular' | 'Body_13_Regular';
  color: 'textStrong' | 'textTertiary';
}

export const TextItem = ({ item, variant = 'Body_13_Regular', color }: Props) => {
  const baseStyle: React.CSSProperties = {
    ...item.style,
    whiteSpace: 'break-spaces',
  };

  const typeStyles: Record<string, React.CSSProperties> = {
    fixed: { flexShrink: 0 },
    ellipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre',
    },
    underline: { textDecoration: 'underline' },
    normal: {},
  };

  const combinedStyle = {
    ...baseStyle,
    ...(typeStyles[item.type] || {}),
  };

  return (
    <Text variant={variant} color={color} style={combinedStyle} onClick={() => item.onClick?.()}>
      {item.type === 'icon' && <img src={item.icon_url} style={item.style} alt='icon' />}
      {item.text}
    </Text>
  );
};
